import type { SearchContext } from '@shared/types/types.ts';
import { isProductItem } from '@tilelist/domain/composition/TileListitem.ts';
import type { TileListItem } from '@tilelist/domain/composition/TileListitem.ts';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';
import { hasProductComparisonBanner } from '@tilelist/domain/feature-visibility/ComparisonBanner.ts';

export const SDA_BTF_POSITION_WITHOUT_PCB = 12;
export const SDA_BTF_POSITION_WITH_PCB = 18;
export const SDA_BTF_MINIMUM_TILES = 20;

/**
 *
 *
 *
 */
export function findInsertIndexAfterNthProduct(items: TileListItem[], n: number): number {
    let productCount = 0;
    const nthProductIndex = items.findIndex((item) => {
        if (isProductItem(item)) productCount++;
        return productCount === n;
    });
    return nthProductIndex >= 0 ? nthProductIndex + 1 : items.length;
}

/**
 *
 *
 *
 *
 */
export function insertSDABillboard(
    tileListItems: TileListItem[],
    searchContext?: SearchContext,
    onex?: OnEx,
): TileListItem[] {
    if (onex?.isToggleActive('EMERGENCY_DISABLE_SDA_HOARDING')) {
        return tileListItems;
    }

    const productItemCount = tileListItems.filter(isProductItem).length;
    if (productItemCount <= SDA_BTF_MINIMUM_TILES) {
        return tileListItems;
    }

    const hasPCB = hasProductComparisonBanner(tileListItems);
    /*                                                                                                   */
    const blackFridaySliderActive = onex?.isToggleActive('REPTILE_1717_BLACK_FRIDAY_SLIDER') ?? false;
    const targetProductPosition =
        hasPCB || blackFridaySliderActive ? SDA_BTF_POSITION_WITH_PCB : SDA_BTF_POSITION_WITHOUT_PCB;
    let insertIndex = findInsertIndexAfterNthProduct(tileListItems, targetProductPosition);
    /*                                                                                           */
    if (blackFridaySliderActive && tileListItems[insertIndex]?.type === 'PCB') insertIndex++;
    const sdaItem = {
        type: 'SponsoredDisplayAd' as const,
        searchContext: getBtfSearchContext(searchContext),
    };

    return [...tileListItems.slice(0, insertIndex), sdaItem, ...tileListItems.slice(insertIndex)];
}

/**
 *
 *
 *
 */
export function getBtfSearchContext(searchContext?: SearchContext): SearchContext | undefined {
    if (!searchContext) return undefined;
    const { searchTerm, assortment, categoryPath, pbk, explicit, implicit, topNImplicit } = searchContext;
    const hasContextFields = [searchTerm, assortment, categoryPath, pbk, explicit, implicit, topNImplicit].some(
        (v) => v !== undefined,
    );
    return hasContextFields ? searchContext : undefined;
}
